import initFacebookPixelIfNeeded from '../tags/facebook-pixel'
import { gtag, GTAG_EVENT, TRACK_CATEGORIES, TRACK_CONTEXTS, TRACK_ACTIONS } from '../index'

export default {
  [TRACK_ACTIONS.routeView]: () => {
    if (process.env.TARGET_ENV === 'production') {
      if (initFacebookPixelIfNeeded()) window.fbq('track', 'PageView')
    }
  },

  [TRACK_CONTEXTS.authenticationPage]: ({ linkId }) => {
    gtag(GTAG_EVENT, TRACK_CONTEXTS.authenticationPage, {
      event_category: TRACK_CATEGORIES.navigation,
      event_label: linkId,
    })
  },

  [TRACK_CONTEXTS.mobileMenu]: ({ linkId }) => {
    gtag(GTAG_EVENT, TRACK_CONTEXTS.mobileMenu, {
      event_category: TRACK_CATEGORIES.navigation,
      event_label: linkId,
    })
  },
}
